var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMap(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 0 1024 1024",
    className: "icon",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M960 160v704c0 35.3-28.7 64-64 64H128c-35.3 0-64-28.7-64-64V160c0-35.3 28.7-64 64-64h768c35.3 0 64 28.7 64 64z",
    fill: "#3D5AFE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M704 512c0-188.6-116.5-349.9-281.4-416H128c-35.3 0-64 28.7-64 64v704c0 35.3 28.7 64 64 64h294.6C587.5 861.9 704 700.6 704 512z",
    fill: "#536DFE"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M101.7 922.3c8 3.6 16.9 5.7 26.3 5.7h768c9.4 0 18.3-2 26.3-5.7L512 512 101.7 922.3z",
    fill: "#8C9EFF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M702 447.8c0-106-86-192-192-192s-192 86-192 192c0 56.9 24.7 107.9 64 143.1l128 128 128-128c39.3-35.2 64-86.3 64-143.1z m-192 64c-35.3 0-64-28.7-64-64s28.7-64 64-64 64 28.7 64 64-28.7 64-64 64z",
    fill: "#FFEA00"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMap);
export default __webpack_public_path__ + "static/media/map.c80be2f2013ce26f27f6336fa033cf42.svg";
export { ForwardRef as ReactComponent };